/**
 * Versioni
 * 1000 2023/03/11 prima versione
 * 
 */

import {
  LitElement,
  html,
  TemplateResult,
  css,
} from 'lit';
import {customElement, property, query } from 'lit/decorators';
import { KelydraUtils } from '../../utils';



/**
 * @customElement k-component-filter
 */
@customElement('k-component-filter')
export class KelydraComponentFilter extends LitElement {

  static styles = [
    css`
    form.field-input {
      position:relative;
    }

    .search-input {
      width: 100%;
      padding: 6px 8px;
      box-sizing: border-box;
      border: 1px solid rgb(221, 221, 221);
      transition: border 0.5s ease 0s;
      outline: none;
    }

    .search-input:invalid {
      border: revert !important;
      background:revert !important;
    }

    .search-input:invalid:focus {
      border: 1px solid blue !important;
      background:lightblue !important;
    }

    .search-close-icon {
	    border:1px solid transparent;
	    background-color: transparent;
	    display: inline-block;
	    vertical-align: middle;
      outline: 0;
      cursor: pointer;
      position: absolute;
      right: 0px;
      top: 0px;
      bottom: 0px
    }

    .search-close-icon:after {
	    content: "X";
	    display: block;
	    height: 15px;
      color:black;
	    z-index:1;
	    margin: auto;
	    padding: 2px;
	    text-align: center;
	    font-size: 12px;
	    cursor: pointer;
    }

    .search-input:not(:valid) ~ .search-close-icon {
	    display: none;
    }   
    `
    ]


  @property()
  placeholder:string;

  @property({type:Number})
  debounce:number = 300;  

  @query('input')
  input:HTMLInputElement  

  dispatchFilterEventDebounce:Function;


  get value():string {
    return this.input.value;
  }  

  protected doResetFilter() {
    this.input.value = '';
    this.onFilter();
  }

  protected onFilter() {
    if (!this.dispatchFilterEventDebounce) {
      if (this.debounce) {
        this.dispatchFilterEventDebounce = KelydraUtils.debounce(this.dispatchFilterEvent, this.debounce, this);
      } else {
        this.dispatchFilterEventDebounce = this.dispatchFilterEvent;
      }
    }

    this.dispatchFilterEventDebounce();
  }

  protected dispatchFilterEvent() {
    let filterEvent = new CustomEvent<ComponentFilterEvent>('filter',{detail:{filter:this.value}});
    this.dispatchEvent(filterEvent);
  }

  render():TemplateResult {
    return html`
      <form class="field-input" @reset=${() => this.doResetFilter()}>
        <input class="search-input" type="text" required @input=${() => this.onFilter()} placeholder=${this.placeholder} >
        <button class="search-close-icon" type="reset"></button>
      </form>  
    `
  }

}

export interface ComponentFilterEvent {
  filter:string;
}

